<script setup>
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import { computed } from 'vue';

const { percentage, width = null } = defineProps({
    percentage: {
        type: Number,
        required: true,
    },
    width: {
        type: String,
        default: null,
    },
});

const color = computed(() => {
    if (percentage >= 100) {
        return 'bg-green-500';
    }

    if (percentage >= 50) {
        return 'bg-yellow-500';
    }

    return 'bg-red-500';
});
</script>

<template>
    <BaseCell>
        <div
            class="flex flex-col gap-1"
            :class="width ? '' : 'w-full min-w-32'"
            :style="width ? { width } : {}"
        >
            <div class="flex items-center gap-2">
                <div
                    class="h-2 flex-1 overflow-hidden rounded-full bg-gray-200"
                >
                    <div
                        class="h-full rounded-full transition-all"
                        :class="color"
                        :style="{ width: `${Math.min(percentage, 100)}%` }"
                    />
                </div>

                <span class="text-sm font-bold whitespace-nowrap tabular-nums">
                    {{ percentage }}%
                </span>
            </div>

            <slot name="footer" />
        </div>
    </BaseCell>
</template>
